import { createTheme } from '@material-ui/core'

export const lightTheme = createTheme({
  palette: {
    primary: {
      main: '#ffffff'
    },
    text: {
      primary: '#393939',
      secondary: '#008F83',
      disabled: '#6f6f6f'
    },
    background: {
      default: '#fff',
      paper: '#fff'
    }
  }
})
